import React from "react";
import styled from "styled-components";

const CustomSelectWrap = styled.div`
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;

const CustomSelectOption = styled.div`
  height: auto;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 5px 8px;
  font-size: 13px;
  border-radius: 7px;
  margin: 0;
  cursor: ${({ $isFull, $fromRestaurant }) =>
    $isFull && !$fromRestaurant ? "default" : "pointer"};
  pointer-events: ${({ $isFull, $fromRestaurant }) =>
    $isFull && !$fromRestaurant ? "none" : "auto"};

  border: 1px solid
    ${({ $isSelected, $isFull, $fromRestaurant, $widgetDark }) => {
      if ($isFull && !$fromRestaurant) return "#d94b4b";
      if ($isSelected) return "var(--widget-main-color, #99b0ad)";
      return $widgetDark
        ? "rgba(246, 241, 232, 0.28)"
        : "rgba(153, 176, 173, 0.75)";
    }};

  background-color: ${({
    $isSelected,
    $isFull,
    $fromRestaurant,
    $widgetDark,
  }) => {
    if ($isFull && !$fromRestaurant) return "#d94b4b";
    if ($isSelected) return "var(--widget-main-color, #99b0ad)";
    return $widgetDark ? "rgba(255, 255, 255, 0.06)" : "transparent";
  }};

  color: ${({ $isSelected, $isFull, $fromRestaurant, $widgetDark }) => {
    if ($isFull && !$fromRestaurant) return "#ffffff";
    if ($isSelected) return "#ffffff";
    return $widgetDark ? "#f6f1e8" : "#343a38";
  }};

  box-sizing: border-box;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    border-color: ${({ $isFull, $fromRestaurant }) =>
      $isFull && !$fromRestaurant
        ? "#d94b4b"
        : "var(--widget-main-color, #99b0ad)"};
    background-color: ${({
      $isSelected,
      $isFull,
      $fromRestaurant,
      $widgetDark,
    }) => {
      if ($isFull && !$fromRestaurant) return "#d94b4b";
      if ($isSelected) return "var(--widget-main-color, #99b0ad)";
      return $widgetDark
        ? "rgba(255, 255, 255, 0.11)"
        : "rgba(153, 176, 173, 0.1)";
    }};
    transform: ${({ $isFull, $fromRestaurant }) =>
      $isFull && !$fromRestaurant ? "none" : "translateY(-1px)"};
  }
`;

const CustomSelectText = styled.span`
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 1.15;
  white-space: nowrap;
`;

const FullText = styled.span`
  color: #ffffff;
  white-space: nowrap;
`;

const getLabel = (item) => {
  const itemString = String(item || "");

  if (itemString === "Lunch" || itemString === "Lunch/f") return "Almoço";
  if (itemString === "Dinner" || itemString === "Dinner/f") return "Jantar";
  if (itemString === "Breakfast" || itemString === "Breakfast/f") {
    return "Pequeno Almoço";
  }
  if (itemString === "reservation") return "Reserva";
  if (itemString === "waiting_list") return "Fila à porta";
  if (itemString.endsWith("/f")) return itemString.slice(0, -2);

  return itemString;
};

function CustomSelect({
  items,
  onSelectChange,
  selectedItem,
  getBorderColor,
  setUpdate = null,
  from_restaurant = false,
  widgetDark = false,
}) {
  const handleItemClick = (item) => {
    const nextValue = selectedItem === item ? "" : item;
    onSelectChange(nextValue);

    if (typeof setUpdate === "function") {
      setUpdate((prev) => (typeof prev === "number" ? prev + 1 : 1));
    }
  };

  return (
    <CustomSelectWrap>
      {items &&
        items.map((item, index) => {
          const itemString = String(item || "");
          const isFull = itemString.endsWith("/f");
          const isSelected = selectedItem === item;

          return (
            <CustomSelectOption
              key={`${itemString}-${index}`}
              id={`custom-select-option-${index}`}
              $isSelected={isSelected}
              $isFull={isFull}
              $fromRestaurant={from_restaurant}
              $widgetDark={widgetDark}
              onClick={() => handleItemClick(item)}
              style={{
                borderColor: getBorderColor ? getBorderColor(item) : undefined,
              }}
            >
              <CustomSelectText>
                <span>{getLabel(itemString)}</span>

                {isFull && !from_restaurant && <FullText>| Lotado*</FullText>}
              </CustomSelectText>
            </CustomSelectOption>
          );
        })}
    </CustomSelectWrap>
  );
}

export default CustomSelect;
